/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIOrgUserCreationRequest
 */
export interface APIOrgUserCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserCreationRequest
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIOrgUserCreationRequest
     */
    roles?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof APIOrgUserCreationRequest
     */
    isOrgAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIOrgUserCreationRequest
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserCreationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserCreationRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserCreationRequest
     */
    lastName?: string;
}

/**
 * Check if a given object implements the APIOrgUserCreationRequest interface.
 */
export function instanceOfAPIOrgUserCreationRequest(value: object): value is APIOrgUserCreationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIOrgUserCreationRequestFromJSON(json: any): APIOrgUserCreationRequest {
    return APIOrgUserCreationRequestFromJSONTyped(json, false);
}

export function APIOrgUserCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrgUserCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'isOrgAdmin': json['is_org_admin'] == null ? undefined : json['is_org_admin'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'email': json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function APIOrgUserCreationRequestToJSON(value?: APIOrgUserCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'roles': value['roles'],
        'is_org_admin': value['isOrgAdmin'],
        'is_active': value['isActive'],
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}

